/* eslint-disable consistent-return */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IAdminAuthUserResponseData, ILoginRequestPayload, IAuthStore, TSavedUrl } from './types';

// ==========================================:
export const initialState: IAuthStore = {
	accessToken: null,
	loginLoader: false,
	savedUrl: null,
	isAuthenticated: false,
};

// ==========================================:
const auth = createSlice({
	name: '@@auth',
	initialState,
	reducers: {
		loginRequest: (state: IAuthStore, action: PayloadAction<ILoginRequestPayload>) => {
			const { payload } = action;
			const loginRequestState = state;

			loginRequestState.loginLoader = true;
		},
		loginSuccess: (state: IAuthStore, action: PayloadAction<IAdminAuthUserResponseData>) => {
			const { payload } = action;
			const loginState = state;

			loginState.isAuthenticated = true;
			loginState.loginLoader = false;

			loginState.accessToken = payload.token;
		},
		authInitState: (state: IAuthStore) => {
			const authInitStateState = state;
			return { ...initialState, savedUrl: authInitStateState.savedUrl };
		},
		saveUrl: (state: IAuthStore, action: PayloadAction<TSavedUrl>) => {
			const { payload } = action;
			const saveUrlState = state;
			saveUrlState.savedUrl = payload;
		},
	},
});

export default auth.reducer;
export const { loginRequest, loginSuccess, saveUrl, authInitState } = auth.actions;
